module.exports = __webpack_public_path__ + "static/media/haggen.8dcb7e7e.svg";